var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import URLX, { currentUrl, equalsUrl, isInternalUrl, relativeUrl } from './Url';
import { scopeLinkAttribute, pushState, replaceState, scrollToHash, isExternalLink } from './history';
export function onLinkClick(link, e, linkProps, deferLoadPromise) {
    return __awaiter(this, void 0, void 0, function* () {
        if (window.IS_IN_EDIT_MODE || !/^http[s]?:/.test(link.href) || !isNormalClick(e) || isExternalLink(link)) {
            return Promise.resolve();
        }
        e.preventDefault();
        const options = {
            linkIdentifier: linkProps && linkProps.linkIdentifier,
            skipPartialCache: linkProps && linkProps.skipPartialCache,
            deferLoadPromise,
            includeAppShellData: linkProps && linkProps.includeAppShellData,
        };
        const promise = equalsUrl(currentUrl(), new URLX(link.href), true) || (linkProps && linkProps.replaceState)
            ? yield replaceState(link.href, options)
            : yield pushState(link.href, options);
        if (link.hash) {
            scrollToHash(link.hash);
        }
        return promise;
    });
}
function isNormalClick(e) {
    return !(e.button > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
}
export const isPdfLink = (url) => {
    if (!url)
        return false;
    if (typeof url === 'string') {
        return url.includes('.pdf');
    }
    else if ('pathname' in url) {
        return url.pathname.includes('.pdf');
    }
    else {
        return url.url.includes('.pdf');
    }
};
function shouldUrlOpenInNewWindow(url) {
    return isPdfLink(url);
}
const Link = React.forwardRef((props, ref) => {
    const { to, linkIdentifier, 
    // tslint:disable-next-line no-shadowed-variable
    replaceState, onPageLoaded, onPageLoadFailed, skipPartialCache, includeAppShellData } = props, restProps = __rest(props, ["to", "linkIdentifier", "replaceState", "onPageLoaded", "onPageLoadFailed", "skipPartialCache", "includeAppShellData"]);
    const url = getUrlFromProps(props);
    const onClick = (e) => {
        let deferLoadPromise = null;
        if (props.onClick) {
            // TODO: Because Link inherits prop types from <a> we can't redefine
            // onClick's type until this:
            // https://github.com/Microsoft/TypeScript/issues/10727
            // has landed in TS
            deferLoadPromise = props.onClick(e);
            if (typeof deferLoadPromise !== 'object' || !deferLoadPromise.then) {
                deferLoadPromise = null;
            }
        }
        if (!e.isDefaultPrevented()) {
            onLinkClick(e.currentTarget, e, props, deferLoadPromise).then(result => {
                if (onPageLoaded) {
                    onPageLoaded(result);
                }
            }, result => {
                if (onPageLoadFailed) {
                    onPageLoadFailed(result);
                }
            });
        }
    };
    const target = React.useMemo(() => { var _a; return (_a = props.target) !== null && _a !== void 0 ? _a : (shouldUrlOpenInNewWindow(props.to) ? '_blank' : undefined); }, [props.target, props.to]);
    if (url && !isInternalUrl(url)) {
        return (React.createElement("a", Object.assign({}, restProps, { ref: ref, href: relativeUrl(url), target: target }), props.children));
    }
    else {
        restProps[scopeLinkAttribute] = 'true';
        const exposedHref = url ? relativeUrl(url) : undefined;
        return (React.createElement("a", Object.assign({}, restProps, { ref: ref, href: exposedHref, onClick: onClick, target: target }), props.children));
    }
});
export default Link;
function getUrlFromProps(props) {
    if (!props.to) {
        return null;
    }
    else if (typeof props.to === 'string') {
        return safeURLX(props.to);
    }
    else if ('url' in props.to) {
        return safeURLX(props.to.url);
    }
    else {
        return props.to;
    }
}
function safeURLX(url) {
    try {
        return new URLX(url);
    }
    catch (e) {
        console.error(`Failed to parse url: '${url}'`, e);
        return currentUrl();
    }
}
